

































import Vue, { PropType } from 'vue';

export type DataType = {
  // innerValue: string|number;
  inputType: 'password' | 'text';
};

export default Vue.extend({
  name: 'GTextField',
  props: {
    value: { type: String as PropType<string>, default: '' },
    name: { type: String as PropType<string>, required: true },
    placeholder: { type: String as PropType<string>, default: '' },
    disabled: { type: Boolean as PropType<boolean>, default: false },
    maxLength: { type: Number as PropType<number>, default: 0 },
    isRequired: { type: Boolean as PropType<boolean>, default: false },
    isPassword: { type: Boolean as PropType<boolean>, default: false },
    underline: { type: Boolean as PropType<boolean>, default: false },
    error: { type: Array as PropType<string[]>, default: () => [] },
  },
  data(): DataType {
    return {
      // innerValue: this.value,
      inputType: this.isPassword ? 'password' : 'text',
    };
  },
  methods: {
    togglePassword() {
      this.inputType = this.inputType === 'password' ? 'text' : 'password';
    },
  },
  watch: {
    innerValue(val: string) {
      if (val && val.length > this.maxLength) {
        this.innerValue = val.substr(0, this.maxLength);
      }
    },
  },
  computed: {
    innerValue: {
      get(): string {
        return this.value;
      },
      set(val: string): void {
        this.$emit('input', val);
      },
    },
  },
  // watch: {
  //   innerValue(val: string) {
  //     this.$emit('input', val);
  //   },
  // },
});
